/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { assetsLicensesBatchesApiUrls } from '@/configs/apiUris/assets-licenses-batches-api-urls'
import {
  ASSET_ID_LABEL,
  ASSET_LICENSING_BATCH_NAME_LABEL,
  CREATOR_LABEL,
  FILE_TYPE_LABEL,
  PUBLISHER_LABEL,
  TITLE_LABEL
} from '@/configs/strings/items-labels'
import { formatEmptyValue } from './assets'
import { normalizeValueArrayToString } from './items'

export const getDefaultCardDetailsData = ({
  publisherValue,
  fileTypeValue,
  assetIdValue
}) => {
  return (
    [
      {
        label: PUBLISHER_LABEL,
        value: publisherValue
      },
      {
        label: FILE_TYPE_LABEL,
        value: fileTypeValue
      },
      {
        label: ASSET_ID_LABEL,
        value: assetIdValue
      }
    ]
  )
}

export const getDefaultSortOptions = () => [
  {
    id: 'title',
    label: TITLE_LABEL
  },
  {
    id: 'assetId',
    label: ASSET_ID_LABEL
  },
  {
    id: 'creator',
    label: CREATOR_LABEL
  },
  {
    id: 'publisher',
    label: PUBLISHER_LABEL
  }
]

export const getDefaultFilterOptions = () => [
  {
    id: 'title',
    label: TITLE_LABEL
  },
  {
    id: 'creator',
    label: CREATOR_LABEL
  },
  {
    id: 'publisher',
    label: PUBLISHER_LABEL
  },
  {
    id: 'fileType',
    label: FILE_TYPE_LABEL
  },
  {
    id: 'assetLicensingBatchName',
    label: ASSET_LICENSING_BATCH_NAME_LABEL,
    type: 'autocomplete',
    api: (inputValue) => `${assetsLicensesBatchesApiUrls.search}?name=${inputValue}`,
    searchResultsKeyData: 'data',
    searchResultsKeyLabel: 'name',
    searchResultsKeyValue: 'name',
    singleResultIsObject: true
  },
  {
    id: 'assetId',
    label: ASSET_ID_LABEL
  }
]

export const pickDefaultFilterOptions = (ids) => {
  const filterOptions = getDefaultFilterOptions()

  return filterOptions.filter(
    option => ids.includes(option.id)
  )
}

export const getBatchNames = ({
  containerValue,
  batchKey,
  batchNameKey
}) => {
  let batchNames

  if (Array.isArray(containerValue)) {
    const assetsLicensesBatch = containerValue.map((object) => {
      const assetsLicensesBatch = object[batchKey]

      return assetsLicensesBatch ? assetsLicensesBatch[batchNameKey] : null
    })
    batchNames = normalizeValueArrayToString(assetsLicensesBatch.filter(Boolean))
  } else if (containerValue?.name) {
    batchNames = containerValue[batchNameKey]
  }

  return formatEmptyValue(batchNames)
}
